import React, { useState } from 'react'
import MyCompanyUpdate from '../../MyCompanyUpdate'
import { useProveedorCompany, useProovedorData } from '../../../components'

const CompanyAccount = () => {
  const { currentCompany, arrayBranchs, setArrayBranchs, currentBranch } = useProveedorCompany() || [];
  const { main_data, setMainData } = useProovedorData();

  const {
    nit: companyID = '',
    nameComany: companyName = '',
    description: companyDescription = '',
    country_origin: country = null,
    theme: colorCompany = '#989d96',
    logo: logoCompany = null
  } = currentCompany || {};

  const temporalNewCompany = {
    companyID,
    companyName,
    companyDescription,
    country,
    colorCompany,
    logoCompany,
    lis_branchs: arrayBranchs
  };

  function reloadData(obj_company, array_branch, new_branches) {
    const list_companys = main_data?.companys ?? [];

    if (obj_company?.updated) {
      const list_company_updated = list_companys.map((obj) => {
        if (companyID == obj?.nit) {
          if (obj?.nit != obj_company?.companyID) obj.nit = obj_company?.companyID;
          if (obj?.nameComany != obj_company?.companyName) obj.nameComany = obj_company?.companyName;
          if (obj?.description != obj_company?.companyDescription) obj.description = obj_company?.companyDescription;
          if (typeof obj_company?.country == 'object' && obj?.country_origin != obj_company.country.label) obj.country_origin = obj_company.country.label; //tocar
          if (obj?.theme != obj_company?.colorCompany) obj.theme = obj_company?.colorCompany;
          if (obj?.logo != obj_company?.logoCompany) obj.logo = obj_company?.logoCompany;
        }
        return obj;
      });

      setMainData((current_data) => ({ ...current_data, companys: list_company_updated }));
    }

    // setArrayBranchs((current_val) => { ALGUN DIA ARREGLAR ESTO
    //   const current_array = [];

    //   for (let i = 0; i < current_val.length; i++) {
    //     const current_list = current_val[i];
    //     const new_list = array_branch[i];
    //     current_array.push({ ...current_list, ...new_list });
    //   }

    //   if (new_branches && (new_branches ?? []).length > 0) {
    //     new_branches.forEach(obj => {
    //       current_array.push(obj);
    //     });
    //   }

    //   return current_array;
    // });
  }

  return (
    <div style={{ padding: '1rem' }}>
      <div className='modal-login' style={{ backgroundColor: 'var(--theme-company)' }}>
        <MyCompanyUpdate key_branch={currentBranch?.key_branch ?? null} dataCompanyProvider={temporalNewCompany} reloadData={reloadData} />
      </div>
    </div>
  )
}

export default CompanyAccount